export const CheckboxField = ({ field, register }) => (
  <div className="flex items-center space-x-2">
    <input
      id={field.id}
      type="checkbox"
      {...register(field.id, field.validation)}
      className="rounded"
      disabled={field.disabled}
    />
    <label htmlFor={field.id} className="text-sm">
      {field.checkboxLabel || field.placeholder}
    </label>
  </div>
);